// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1bhI5","col":"styles_col__1pz2Q","fulfillmentStatus":"styles_fulfillmentStatus__3dETO","emailCol":"styles_emailCol__3pACK"};